import { stringify } from 'qs';

export interface SmartBannerLink {
  path?: string;
  params?: Record<string, string | number | undefined | string[] | number[] | undefined[]>;
  linkType?: 'webviewLink' | 'deepLink' | undefined;
  cgntId?: string | undefined;
  trackcode?: string | undefined;
}
export const makeDeepLink = ({ path, params, linkType = 'deepLink', cgntId, trackcode }: SmartBannerLink): string => {
  const queryParamsForDeepLink = stringify(
    {
      ...params,
      via: 'mweb',
      viaCgntId: cgntId || undefined,
      trackcode: trackcode || undefined,
    },
    { addQueryPrefix: true, skipNulls: true, arrayFormat: 'comma' },
  );

  if (linkType === 'webviewLink') {
    const webviewUrl = path?.includes('?')
      ? `${path}${queryParamsForDeepLink.replace('?', '&')}`
      : `${path}${queryParamsForDeepLink}`;
    return `yanoljamotel://wv?url=${encodeURIComponent(webviewUrl)}`;
  }

  // 앱 딥링크 스킴
  const appDeepLink = `yanoljamotel://${path}${queryParamsForDeepLink}`;

  // onelink로 전달할 최종 URL 파라미터 생성
  const finalUrlParams = stringify(
    {
      pid: 'smartbanner', // 캠페인 식별자
      af_click_lookback: '1d', // 클릭 후 리타게팅 가능 기간
      is_retargeting: 'true', // 리타게팅 여부
      af_reengagement_window: '30d', // 리타게팅 기간 설정
      af_force_deeplink: 'true', // 앱 강제 실행 옵션
      af_dp: appDeepLink, // 딥링크 주소
      deep_link_value: appDeepLink, // 백업 딥링크 값
    },
    { addQueryPrefix: true, skipNulls: true },
  );

  return `https://yanolja.onelink.me/tmFm${finalUrlParams}`;
};
